module.exports = __webpack_public_path__ + "media/video_instruction.b076e806.webm";